import React, { FC } from 'react';
import { Notification as NotificationWSR } from '../wixCommon';
import { IOuter } from './Notification.types';

export const Notification: FC<IOuter> = ({
  theme,
  label,
  dataHook,
  onClose,
  onCloseButtonClick,
}) => {
  return (
    <NotificationWSR
      show
      theme={theme}
      dataHook={dataHook}
      onClose={onClose}
      autoHideTimeout={5000}
    >
      <NotificationWSR.TextLabel>{label}</NotificationWSR.TextLabel>

      <NotificationWSR.CloseButton onClick={onCloseButtonClick} />
    </NotificationWSR>
  );
};
